import { Space } from '../../../../../../components/core-v2'
import { TopupWithdrawStepState } from '../../../../../trade-editor/modules/01-topup-withdraw/state/topup-withdraw-slice'
import { StepName } from '../../../00-builder/state/builder-slice'
import { NewNoteState } from '../../../01-note/new-note/validation-rules'
import { NoteStepState } from '../../../01-note/note/note-step-slice'
import { TermsStepState } from '../../../02-terms/state/terms-slice'
import { PortfolioStepState } from '../../../03-portfolio/state/portfolio-slice'
import { StrategyStepState } from '../../../04-strategy/state/strategy-slice'
import { CompleteStepState } from '../../complete-slice'
import { ApproveFees } from './fees'
import { ApproveNote } from './note'
import { ApprovePortfolio } from './portfolio'
import { ApproveStrategy } from './strategy'
import { ApproveTerms } from './terms'
import { ApproveTopUpWithdraw } from './topUpWithdraw'

type Props = {
  complete: CompleteStepState
  goToStep: (stepName: StepName) => void
  includeNoteApproval: boolean
  includePortfolioApproval: boolean
  includeStrategyApproval: boolean
  isThereAnyChange: boolean
  newNote: NewNoteState
  note: NoteStepState
  portfolio: PortfolioStepState
  setIsApproved: (stepName: StepName | 'fees') => void
  strategy: StrategyStepState
  terms?: TermsStepState
  topUpWithdraw?: TopupWithdrawStepState
}

export function Approval({
  complete,
  goToStep,
  includeNoteApproval,
  includePortfolioApproval,
  includeStrategyApproval,
  isThereAnyChange,
  newNote,
  note,
  portfolio,
  setIsApproved,
  strategy,
  terms,
  topUpWithdraw
}: Props) {
  return (
    <>
      {topUpWithdraw && (
        <Space mb={6}>
          <ApproveTopUpWithdraw
            isApproved={complete.approvals.topupWithdraw}
            state={topUpWithdraw}
            onChangeIsApproved={() => setIsApproved('topupWithdraw')}
            onClickEdit={() => goToStep('topupWithdraw')}
          />
        </Space>
      )}

      {includeNoteApproval && (
        <Space mb={6}>
          <ApproveNote
            isApproved={complete.approvals.note}
            newNote={newNote}
            note={note}
            onChangeIsApproved={() => setIsApproved('note')}
            onClickEdit={() => goToStep('note')}
          />
        </Space>
      )}

      {terms && (
        <Space mb={6}>
          <ApproveTerms
            assetSummary={portfolio.selfSelect?.assets}
            isApproved={complete.approvals.terms}
            terms={terms}
            onChangeIsApproved={() => setIsApproved('terms')}
            onClickEdit={() => goToStep('terms')}
          />
        </Space>
      )}

      {includePortfolioApproval && (
        <Space mb={6}>
          <ApprovePortfolio
            isApproved={complete.approvals.portfolio}
            portfolio={portfolio}
            onChangeIsApproved={() => setIsApproved('portfolio')}
            onClickEdit={() => goToStep('portfolio')}
          />
        </Space>
      )}

      {includeStrategyApproval && (
        <Space mb={6}>
          <ApproveStrategy
            isApproved={complete.approvals.strategy}
            strategy={strategy.selectedStrategy}
            onChangeIsApproved={() => setIsApproved('strategy')}
            onClickEdit={() => goToStep('strategy')}
          />
        </Space>
      )}

      {(includeNoteApproval || includePortfolioApproval || includeStrategyApproval) && (
        <ApproveFees
          isApproved={complete.approvals.fees}
          note={note}
          portfolio={portfolio}
          strategy={strategy}
          onChangeIsApproved={() => setIsApproved('fees')}
        />
      )}

      {!isThereAnyChange && (
        <Space isflex justifyContent="center">
          You haven't made any changes
        </Space>
      )}
    </>
  )
}
